// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lw7d","toggleWrap":"styles_toggleWrap__1Yi77","content":"styles_content__2M4XJ","selectAreaCode":"styles_selectAreaCode__3cjsp"};